export interface ProjectOffHoldDialogModel {
  projectName?: string;
  message?: string;
}

export interface ProjectOffHoldIncrementModel {
  units: string;
  increment: number;
}

export function ProjectOffHoldIncrementModelFactory(json?: any): ProjectOffHoldIncrementModel {
  if (!json || !json.increment) return undefined;

  return {
    units: json.units || "weeks",
    increment: (+json.increment >= 0 ? +json.increment : 0),
  };
}
